import { Div, Container, LeftDiv, RightDiv, Footer } from './styles';
import LoginView from '../../views/Login/index.jsx';
import bgLoginMedico from '../../assets/bg-login2.png';
import { deleteCookies } from '../../utils/functions';

function Login() {

  const siteUrl = "https://www.cedap.com.br/duvidas"; // URL do site que será aberto

  // Deleta cookies ao montar o componente
  deleteCookies();

  const handleClick = () => {
    window.open(siteUrl, "_blank"); // Abre o site em uma nova aba
  };

  return (
    <Div>
      <Container>
        <LeftDiv background={bgLoginMedico}>
          <h1>
            “<b>Excelência</b> em <b>saúde,</b><br />
            porque sua <b>vida vale<br />
            muito</b> para <b>nós!</b>”
          </h1>
        </LeftDiv>

        <RightDiv>
          {/* <h1>Área&nbsp;Paciente</h1> */}
          <LoginView />
        </RightDiv>
      </Container>

   <Footer>
  Precisa de ajuda? Confira as{''}
  <button onClick={handleClick} style={{ border: "none", background: "none", cursor: "pointer", color: "#007bff" }}>
    <strong>Perguntas Frequentes.</strong>
  </button>
  
</Footer>

    </Div>
  );
}

export default Login;
